import type { CommonHeaderProps } from 'corgi-types';

import {
  CartSubscription,
  UserAccountSubscription,
  WishlistSubscription,
} from 'common/event-bus/EventSubscription';
import { ACTION_ITEM_IDS } from './constants';
import type { ActionItemConfig } from './types';

export const filterVisibleActionItems = (
  items: ActionItemConfig[],
  isLoggedIn: boolean,
  showOnlySearchIcon: boolean
) =>
  items.filter(
    ({ auth, id }) =>
      (typeof auth === 'undefined' || auth === isLoggedIn) &&
      !(showOnlySearchIcon && id === ACTION_ITEM_IDS.USER_ACCOUNT)
  );

type GetActionItemsParams = CommonHeaderProps;

export const getActionItems = ({
  customer,
  cartCount,
  wishlistCount,
}: GetActionItemsParams): ActionItemConfig[] => [
  {
    // INFO: We are using the same ids to trick React into
    // thinking that those items are the same
    id: ACTION_ITEM_IDS.USER_ACCOUNT,
    icon: 'Account',
    label: 'h24_register',
    url: 'h24_login_page_url',
    showTooltip: true,
    initialValue: customer,
    auth: false,
  },
  {
    id: ACTION_ITEM_IDS.USER_ACCOUNT,
    icon: 'Account',
    label: 'h24_my_account',
    url: 'h24_my_overview_url',
    showTooltip: true,
    auth: true,
    initialValue: customer,
    Subscription: UserAccountSubscription,
  },
  {
    id: ACTION_ITEM_IDS.WISHLIST,
    icon: 'Wishlist',
    label: 'h24_wishlist',
    url: 'h24_wishlist_url',
    initialValue: wishlistCount,
    Subscription: WishlistSubscription,
  },
  {
    id: ACTION_ITEM_IDS.CART,
    icon: 'Cart',
    label: 'h24_cart',
    url: 'h24_cart_url',
    countThreshold: 0,
    initialValue: cartCount,
    Subscription: CartSubscription,
  },
];
